/**
 * Area code rules for the number a new workflow buys on create. Shared by the
 * sidebar field and the new line confirm modal so both validate the same way.
 * Same 100-999 range as the buy-numbers admin form.
 */
export const AREA_CODE_RULES = {
    required: 'Area code is required so a phone number can be provisioned for this workflow',
    pattern: {
        value: /^[0-9]{3}$/,
        message: 'Area code must be exactly 3 digits',
    },
    validate: (value: string) => {
        const num = parseInt(value, 10);
        return (num >= 100 && num <= 999) || 'Area code must be between 100 and 999';
    },
};

/**
 * NANP area code of a +1 number ('+14155550123' gives '415'), or '' when the
 * number is not a valid +1 number. 555 also gives '', as it is a placeholder
 * rather than a real area code and buying a number in it fails.
 */
export const areaCodeFromPhoneNumber = (phoneNumber?: string | null): string => {
    const match = /^\+1([2-9]\d{2})\d{7}$/.exec((phoneNumber ?? '').replace(/[\s().-]/g, ''));
    return match && match[1] !== '555' ? match[1] : '';
};
